import React from 'react';
import { css } from '@emotion/css';
import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { useNodeStatesContext, useReactNodeView } from '@lyearn/lygo-core';
import { Collapse } from '@lyearn/ui';

const placeholderStyles = (placeholderString?: string) => css`
  .ProseMirror__contentDOM > p::before {
    color: var(--text-placeholder);
    display: block;
    pointer-events: none;
    content: '${placeholderString}';
    height: 0;
  }
`;

// empty toggle_block_content node size
const EMPTY_NODE_SIZE = 4;

const ToggleItemContentEditable: React.FC = () => {
  const { t } = useTranslation();
  const { editableComponentRef, node, view, getPos } = useReactNodeView();
  const { getNodeState } = useNodeStatesContext();
  const contentPlaceholderStyles = React.useMemo(
    () => placeholderStyles(t('Lygo:Menu.toggle_list.EmptyContentPlaceholder')),
    [t],
  );

  if (!node || !getNodeState || !view) {
    return null;
  }

  const parentId =
    typeof getPos === 'function' && getPos()
      ? view.state.doc.resolve(getPos()!).parent.attrs.id
      : null;

  const expanded = parentId ? getNodeState(parentId)?.expanded : false;

  return (
    <Collapse
      className={c('w-full', {
        [`${contentPlaceholderStyles} cursor-pointer`]:
          view?.editable && node.nodeSize === EMPTY_NODE_SIZE,
      })}
      classes={{ hidden: 'hidden' }}
      in={expanded}
      timeout={0}>
      <div ref={editableComponentRef} />
    </Collapse>
  );
};

export default ToggleItemContentEditable;
